import { render, staticRenderFns } from "./ElectronicFlowsPage.vue?vue&type=template&id=2d070d12&scoped=true&"
import script from "./ElectronicFlowsPage.vue?vue&type=script&lang=js&"
export * from "./ElectronicFlowsPage.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicFlowsPage.vue?vue&type=style&index=0&id=2d070d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d070d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d070d12')) {
      api.createRecord('2d070d12', component.options)
    } else {
      api.reload('2d070d12', component.options)
    }
    module.hot.accept("./ElectronicFlowsPage.vue?vue&type=template&id=2d070d12&scoped=true&", function () {
      api.rerender('2d070d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/ElectronicFlowsPage.vue"
export default component.exports